export default "__VITE_ASSET__CSZEkeJw__"